// src/components/Flow/Flow.styles.ts

import styled from 'styled-components';

export const FlowContainer = styled.div`
  position: relative;
  flex: 1; /* Use flex to take up the remaining space */
  width: 100%;
  overflow: hidden;
`;
